// SkillArtifact — espelha o contrato em raios/docs/skill-output-contract.md
//
// Backend: src/engine/execution/skill-artifacts.ts (PersistedArtifact, PersistedMediaGroup)
// Frontend: SkillOutputRenderer + ArtifactDisplay leem skill_executions.output.artifacts[]
//           tipados via esta interface.
//
// Compat: outputs antigos sem `type` continuam funcionando via fallback heuristico
// no ArtifactsGrid (renderValue legado).

export type ArtifactType = 'image' | 'document' | 'video' | 'audio';

/**
 * Artifact ja persistido em S3 (apos commitArtifacts no backend). UI sempre recebe
 * com signed_url + storage_path; nunca com local_path (que e working space privado).
 */
export interface SkillArtifact {
  type: ArtifactType;
  mime: string;
  name: string;
  /** URL temporaria (signed) — clickavel + Telegram-fetchable. TTL 7d. */
  signed_url: string;
  /** Path interno no bucket raios-{tenant_id}. Usado pra debug/audit. */
  storage_path: string;
  /** ISO 8601. Quando expira a signed_url. */
  expires_at: string;
  /** Bytes do arquivo original. */
  bytes: number;
  /** Caption opcional (usado em UI + Telegram caption). */
  caption?: string;
}

/**
 * Media group para carrosseis (Instagram, comparacoes side-by-side).
 * Restricoes: 2-10 items, todos do mesmo tipo image OU video.
 */
export interface SkillArtifactMediaGroup {
  type: 'media_group';
  caption?: string;
  items: SkillArtifact[];
}

export type SkillArtifactOrGroup = SkillArtifact | SkillArtifactMediaGroup;

/**
 * Type guard runtime para distinguir Artifact discriminado vs valor desconhecido
 * (ex: artifacts antigos sem `type` field). Frontend usa isso pra decidir
 * entre ArtifactDisplay novo e renderValue legado.
 */
export function isSkillArtifactOrGroup(v: unknown): v is SkillArtifactOrGroup {
  if (typeof v !== 'object' || v === null) return false;
  const o = v as Record<string, unknown>;
  if (typeof o['type'] !== 'string') return false;

  if (o['type'] === 'media_group') {
    return Array.isArray(o['items']) && o['items'].length > 0;
  }

  if (!['image', 'document', 'video', 'audio'].includes(o['type'] as string)) return false;
  return typeof o['signed_url'] === 'string' && typeof o['name'] === 'string';
}
